import { Directive , HostListener } from '@angular/core';

@Directive({
  selector: '[PreventDragAndDrog]'
})
export class PreventDragAndDrogDirective {

  constructor() { }

  @HostListener("drop", ["$event"])
    onDrog(event: ClipboardEvent) {
        event.preventDefault();
    }
    @HostListener("dragover", ["$event"])
    ondragover(event: ClipboardEvent) {
        event.preventDefault();
    }
    // @HostListener("paste", ["$event"])
    // onPaste(event: ClipboardEvent) {
    //     event.preventDefault();
    // }

}
